import { assertInInjectionContext, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { AuthState } from '@tsin-core/store/auth/auth.state';

export const otpGuard: CanActivateFn = (route, state) => {
  const router: Router = inject(Router);
  const store: Store = inject(Store);

  // Get the state values from the AuthState
  const isOtpEnabled = store.selectSnapshot(AuthState.isOtpEnabled);
  const otpValidated = store.selectSnapshot(AuthState.isOtpValidated);

  // If OTP is enabled but not validated, redirect to the OTP screen
  if (isOtpEnabled && !otpValidated) {
    router.navigate(['/otp-screen/app']); // Redirect to OTP validation (App or Email based on implementation)
    return false;
  }

  // If OTP is enabled but not validated, redirect to the OTP screen
  if (!isOtpEnabled && !otpValidated) {
    router.navigate(['/otp-screen/app']); // Redirect to OTP validation (App or Email based on implementation)
    return false;
  }

  // Allow access if OTP is either not enabled or already validated
  return true;
};
